import {createAction} from 'redux-act';

export const OPEN_CANCELLATION_REFUND_MODAL = createAction(
  'cancellationRefund/OPEN_CANCELLATION_REFUND_MODAL'
);
export const MAKE_REFUND = createAction('cancellationRefund/MAKE_REFUND');
